import type { FeatureAccessOptions } from '@blueshift-ui/auth/dist/types';

import useFeatureAccess from '@blueshift-ui/auth/dist/hooks/use-feature-access';

const criteria: FeatureAccessOptions = {
  every: [{ productState: 'vt4s' }, { role: 'student' }],
};

const useIsVt4sStudent = () => useFeatureAccess({ criteria });

export default useIsVt4sStudent;
